module.exports = __webpack_public_path__ + "assets/Angle60.f79d9fa93d5e07e0bb541fedf845080c.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/Angle60.gmt
// module id = 896
// module chunks = 0